import React from "react";
import { Link } from "react-router-dom"
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import swal from 'sweetalert';
import { useParams } from "react-router-dom";
import Form from "react-validation/build/form";
import { Alert } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import APIConfig from "../../../api/APIConfig";

import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    HStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Textarea,
} from '@chakra-ui/react';

function FormTolakProposal() {
    const navigate = useNavigate();
    const [alasanPenolakan, setAlasanPenolakan] = useState('');
    const [validation, setValidation] = useState({});
    const { id } = useParams();

    const editAlasan = async (e) => {
        e.preventDefault();
        await APIConfig.put(`v1/proposal/tolak/${id}`, {
            alasanPenolakan: alasanPenolakan,
        })
        .then(() => {
            console.log("berhasil") 
            swal({
                title: "Alasan penolakan telah berhasil tersimpan",
                icon: "success",
                button: "OK",
            }).then(() => {
                APIConfig.put(`v1/proposal/status/${id}`, {
                statusProposal: "Ditolak",
                })
                .then(() => {
                    navigate("/admin/verifikasi/proposal");
        
                })
            });
        })
        .catch((error) => {
            console.log(error);
            setValidation(error.response.data);
        })
        
    };


    return (
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                fontFamily={'Inter'}>
                Form Penolakan Proposal
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to="/admin/verifikasi/proposal"> Daftar Proposal </Link>
                <p> / </p>
                <Link to={`/admin/detail/proposal/${id}`}> Detail Proposal </Link>
                <p> / </p>
                <Link to=""> Form Penolakan Proposal</Link>
            </HStack>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        color={useColorModeValue('gray.700', 'white')}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Alasan Penolakan Proposal
                    </Heading>
                    
                    {
                        validation.errors &&
                            <Alert variant="danger">
                                <ul class="mt-0 mb-0">
                                    { validation.errors.map((error, index) => (
                                        <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                    )) }
                                </ul>
                            </Alert>
                    }
                    
                    <Form p={6} onSubmit={editAlasan}>
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='alasan'>Berikan Alasan Penolakan</FormLabel>
                        <Textarea 
                        type='text'
                        id='alasan' 
                        placeholder='Mengapa proposal ini ditolak?' 
                        value={alasanPenolakan}
                        onChange={(e) => setAlasanPenolakan(e.target.value)}/>
                        </FormControl>

                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Kirim
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormTolakProposal;